<div class="hexWrap">
    <div class="hex" [class.disable]="!hexData?.visibility" (mouseenter)="mouseEnter($event)" (mouseleave)="mouseLeave($event)">
        <div class="hexIcon1">
            <img class="icon1" [src]="(hexData?.visibility)? (( hexData?.hover)?(hexData?.hoverUrl):(hexData?.imgUrl)) : (hexData?.disableUrl)">
        </div>
        <div class="hexText1">
            <p class="text1">{{hexData?.label}}</p>
        </div>
    </div>
</div>